<p-table
  #dt
  [value]="clubesRegistred"
  [rows]="10"
  [paginator]="true"
  [globalFilterFields]="['name']"
  [rowHover]="true"
  dataKey="id"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [showCurrentPageReport]="false"
  class="p-datatable-sm table'"
>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between">
      <div style="text-align: left">
        <p-button
          icon="pi pi-external-link"
          m
          label="Exportar"
          (onClick)="exportFinancialReport()"
        />
      </div>
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          (input)="dt.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Search..."
        />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="name" class="table__header">
        Club <p-sortIcon field="rating" />
      </th>
      <th pSortableColumn="idNumber" class="table__header">
        Cantidad Inscritos Ordinarios <p-sortIcon field="name" />
      </th>
      <th pSortableColumn="name" class="table__header">
        Valor Inscritos Ordinarios
      </th>
      <th pSortableColumn="lastName" class="table__header">
        Cantidad Inscritos Extraordinarios <p-sortIcon field="price" />
      </th>

      <th pSortableColumn="birthDay" class="table__header">
        Valor Inscritos Extraordinarios <p-sortIcon field="inventoryStatus" />
      </th>

      <th pSortableColumn="level" class="table__header">
        Valor Inscripción Club <p-sortIcon field="inventoryStatus" />
      </th>

      <th pSortableColumn="level" class="table__header" *ngIf="competition.hasCrosselling"> 
        Venta Cruzada <p-sortIcon field="inventoryStatus" />
      </th>

      <th pSortableColumn="level" class="table__header">
        Total a Pagar <p-sortIcon field="inventoryStatus" />
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-club>
    <tr class="table__row">
      <td>
        {{ club.name }}
      </td>

      <td>{{ getRegistrarionByClub(club.id, 'ORDINARY').length }}</td>
      <td>
        {{ calculateAmountByClub(club.id, 'ORDINARY') }}
      </td>
      <td>{{ getRegistrarionByClub(club.id, 'EXTRAORDINARY').length }}</td>
      <td>
        {{ calculateAmountByClub(club.id, 'EXTRAORDINARY') }}
      </td>
      <td>
        {{ getClubAmount(club.id) }}
      </td>
      <td *ngIf="competition.hasCrosselling">
        <span *ngIf="getCrossSellingDescriptionByClub(club.id) as desc">
          {{ desc }} = ${{ getCrossSellingAmount(club.id) | number }}
        </span>
        <span *ngIf="!getCrossSellingDescriptionByClub(club.id)">
          $0
        </span>
      </td>
      <td>
        {{ calculateTotalAmount(club.id) }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between">
      {{ clubesRegistred ? clubesRegistred.length : 0 }} registros en total.
    </div>
  </ng-template>
</p-table>

<div *ngIf="competition.hasCrosselling" class="mt-4">
  <h3>Resumen Productos Venta Cruzada</h3>
  <p-table
    [value]="getCrossSellingProductSummary()"
    [rows]="10"
    [paginator]="false"
    [rowHover]="true"
    class="p-datatable-sm"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="table__header">Producto</th>
        <th class="table__header">Cantidad</th>
        <th class="table__header">Precio Unitario</th>
        <th class="table__header">Total</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
      <tr class="table__row">
        <td>{{ product.name }}</td>
        <td>{{ product.quantity }}</td>
        <td>{{ product.unitPrice | number }}</td>
        <td>{{ product.total | number }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4">No hay productos de venta cruzada.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
